import { StaticImage } from '@/common/constants/displateRoutes';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';

/**
 * @returns '/browse-brands'
 */
export const RouteToBrowseBrandsPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: '/browse-brands', target: 'elysium' });
};

export const BrowseBrandsConfig: PageConfig = {
  readableName: 'Browse brands page',
  analyticsGaName: 'browse-brands',
  analyticsAthenaName: 'browse-brands',
  pagePathnames: ['/browse-brands'],
  displayPromoBar: true,
  defaultMeta: {
    title: 'Officially Licensed Posters | Browse Brands | Displate',
    description:
      'Officially Licensed Posters from amazing brands: Star Wars, DC Comics, Marvel, Cyberpunk, The Witcher, and many more! Buy yours on Displate!',
    coverImage: StaticImage('/images/brands/og_image.webp'),
  },
};

export const BrowseBrandsHeaderHeights = {
  desktop: 162,
  mobile: 162,
};
